import { useQuery } from '@tanstack/react-query';
import { factoryGetOfficeConsentKey } from '../factories/queries';
import { ConsentsService } from '../services';
import type { IOfficeConsent } from '../types/OfficeConsent';
import type { IGetOfficeConsentParameters } from '../types/OfficeConsent.parameters';

export const useGetOfficeConsent = (params: IGetOfficeConsentParameters) => {
  const { data, error, isError, isLoading, isFetching } = useQuery<IOfficeConsent>({
    queryKey: factoryGetOfficeConsentKey(params),
    queryFn: () => ConsentsService.getOfficeConsent(params),
    refetchOnWindowFocus: false,
    retry: false,
  });

  return {
    data,
    error,
    isError,
    isInitialLoading: isLoading,
    isLoading: isLoading || isFetching,
  };
};
